<template>
  <v-card class="shadowCard">
    <v-card-title class="text-subtitle-1">
      {{ titulo }}
      <span class="ml-2 grey--text text-body-2">({{ filtradas.length }})</span>
      <span class="ml-2 grey--text text-body-2" v-if="rangoTexto">{{ rangoTexto }}</span>
      <v-chip
        v-if="bloqueado || congelado"
        class="ml-2"
        x-small
        color="blue-grey"
        text-color="white"
      >
        {{ bloqueado ? 'Bloqueado' : 'Congelado' }}
      </v-chip>
      <v-spacer></v-spacer>
      <v-select
        v-if="!escuela"
        v-model="filtroEscuela"
        :items="opcionesEscuela"
        dense
        filled
        hide-details
        class="filtro-escuela"
        style="max-width: 180px;"
      />
      <v-btn
        class="ml-2"
        color="success"
        small
        tile
        :disabled="!filtradas.length"
        @click="descargarExcel"
      >
        <v-icon left small>mdi-microsoft-excel</v-icon>
        Excel
      </v-btn>
      <v-btn
        v-if="puedeGestionar"
        class="ml-2"
        color="primary"
        small
        tile
        @click="abrirAgregar"
      >
        <v-icon left small>mdi-plus</v-icon>
        Agregar
      </v-btn>
    </v-card-title>
    <v-card-text>
      <div class="mb-3 grey--text text-caption">
        La meta es un <b>%</b> de avance sobre reinscribibles.
        Semana 2 es el RI al siguiente ciclo (14 días desde el inicio).
        Faltan es lo que falta para el objetivo.
        <span v-if="bloqueado">Los montos y asignaciones ya no se pueden modificar.</span>
      </div>
      <v-data-table
        :key="'bono-ri-' + filtradas.length"
        :headers="headersVisibles"
        :items="filtradas"
        :loading="cargando"
        class="elevation-0"
        dense
        item-key="id"
        :items-per-page="-1"
        hide-default-footer
        mobile-breakpoint="0"
        :no-data-text="cargando ? 'Cargando…' : 'No hay recepcionistas para mostrar'"
      >
        <template v-slot:item.reinscribibles="{ item }">
          {{ cargandoAvance ? '…' : mostrarNum(item.reinscribibles) }}
        </template>

        <template v-slot:item.meta="{ item }">
          <v-text-field
            v-if="puedeGestionar"
            :value="item.meta"
            type="number"
            dense
            filled
            hide-details
            min="0"
            max="100"
            suffix="%"
            @change="guardarPlantel(item, 'meta', $event)"
          />
          <span v-else>{{ mostrarNum(item.meta) }}%</span>
        </template>

        <template v-slot:item.objetivo="{ item }">
          {{ cargandoAvance ? '…' : mostrarNum(item.objetivo) }}
        </template>

        <template v-slot:item.lleva_s2="{ item }">
          <v-chip
            small
            class="chip-lleva"
            :color="cargandoAvance ? 'grey' : (item.alcanzado_s2 ? 'green' : 'red')"
            text-color="white"
            @click="abrirAlumnos(item)"
          >
            {{ cargandoAvance ? '…' : ((item.lleva_s2 || 0) + ' (' + (item.pct_s2 || 0) + '%)') }}
          </v-chip>
        </template>

        <template v-slot:item.faltan="{ item }">
          {{ cargandoAvance ? '…' : mostrarNum(faltanDe(item)) }}
        </template>

        <template v-slot:item.bono_general="{ item }">
          <v-text-field
            v-if="puedeGestionar"
            :value="item.bono_general"
            type="number"
            dense
            filled
            hide-details
            min="0"
            prefix="$"
            @change="guardarPlantel(item, 'bono_general', $event)"
          />
          <span v-else>{{ formatMoney(item.bono_general) }}</span>
        </template>

        <template v-slot:item.bono_personal="{ item }">
          <v-text-field
            v-if="puedeGestionar"
            :value="item.bono_personal"
            type="number"
            dense
            filled
            hide-details
            min="0"
            prefix="$"
            @change="guardarPersonal(item, $event)"
          />
          <span v-else>{{ formatMoney(item.bono_personal) }}</span>
        </template>

        <template v-slot:item.acciones="{ item }">
          <v-btn
            v-if="puedeGestionar"
            icon
            small
            color="red darken-1"
            @click="confirmarEliminar(item)"
          >
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="dialogAlumnos" max-width="720">
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold">
          RI semana 2 — {{ plantelSeleccion }}
          <v-spacer />
          <v-btn icon small @click="dialogAlumnos = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersAlumnos"
            :items="alumnosSeleccion"
            item-key="id_alumno"
            dense
            elevation-0
            :items-per-page="25"
            mobile-breakpoint="0"
            no-data-text="Este plantel no tiene RI a semana 2"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAgregar" max-width="520">
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold">
          Agregar persona
          <v-spacer />
          <v-btn icon small @click="dialogAgregar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="nuevoTrabajador"
            :items="trabajadores"
            item-text="nombre_completo"
            item-value="id_trabajador"
            label="Persona"
            filled
            dense
            hide-details
            class="mb-4"
            return-object
            clearable
          />
          <v-autocomplete
            v-model="nuevoPlantel"
            :items="planteles"
            item-text="plantel"
            item-value="id_plantel"
            label="Plantel"
            filled
            dense
            hide-details
            return-object
            clearable
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn small text @click="dialogAgregar = false">Cancelar</v-btn>
          <v-btn
            small
            tile
            color="primary"
            :loading="guardando"
            :disabled="!nuevoTrabajador || !nuevoPlantel"
            @click="agregar"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEliminar" max-width="420">
      <v-card>
        <v-card-title class="text-subtitle-1">Quitar persona</v-card-title>
        <v-card-text>
          ¿Quitar a <b>{{ filaEliminar && filaEliminar.nombre_completo }}</b> de
          <b>{{ filaEliminar && filaEliminar.plantel }}</b>?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn small text @click="dialogEliminar = false">Cancelar</v-btn>
          <v-btn small tile color="red darken-1" dark :loading="guardando" @click="eliminar">
            Quitar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import validarErrores from '@/mixins/validarErrores'
import Alerta from '@/components/alertas/Alerta.vue'
import { filasBonoRiDelUsuario } from '@/utils/bonoRiAsignacion'

const IDERPS_EDITAN = [1, 334, 568]
const BONO_RI_BLOQUEADO = true

export default {
  name: 'TablaBonoRI',

  mixins: [validarErrores],

  components: { Alerta },

  props: {
    escuela: { type: Number, default: 0 },
    titulo: { type: String, default: 'Bono de RI' },
    soloAsignadas: { type: Boolean, default: false },
  },

  data() {
    return {
      filtroEscuela: Number(this.escuela) || 0,
      opcionesEscuela: [
        { text: 'Todas', value: 0 },
        { text: 'INBI', value: 1 },
        { text: 'FAST', value: 2 },
      ],
      filas: [],
      alumnosPorPlantel: {},
      cicloAct: null,
      cicloSig: null,
      fecha_corte: '',
      congelado: false,
      bloqueado: BONO_RI_BLOQUEADO,
      cargando: false,
      cargandoAvance: false,
      guardando: false,
      dialogAlumnos: false,
      dialogAgregar: false,
      dialogEliminar: false,
      plantelSeleccion: '',
      personaSeleccion: '',
      alumnosSeleccion: [],
      trabajadores: [],
      planteles: [],
      nuevoTrabajador: null,
      nuevoPlantel: null,
      filaEliminar: null,
      headers: [
        { text: 'Persona', value: 'nombre_completo' },
        { text: 'Plantel', value: 'plantel' },
        { text: 'Reinscribibles', value: 'reinscribibles', width: 120 },
        { text: 'Meta %', value: 'meta', width: 110 },
        { text: 'Objetivo', value: 'objetivo', width: 90 },
        { text: 'Semana 2', value: 'lleva_s2', width: 130 },
        { text: 'Faltan', value: 'faltan', width: 80 },
        { text: 'Bono general', value: 'bono_general', width: 150 },
        { text: 'Bono personal', value: 'bono_personal', width: 130 },
        { text: '', value: 'acciones', width: 56, sortable: false },
      ],
      headersAlumnos: [
        { text: 'Alumno', value: 'nombre' },
        { text: 'Grupo', value: 'grupo' },
        { text: 'Plantel', value: 'plantel' },
      ],
    }
  },

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    puedeEditar() {
      const id = Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp)
      return IDERPS_EDITAN.includes(id)
    },
    puedeGestionar() {
      return this.puedeEditar && !this.soloAsignadas && !this.bloqueado && !this.congelado
    },
    iderp() {
      const u = this.getdatosUsuarioERPERP || {}
      const raw = u.iderp != null && u.iderp !== '' ? u.iderp : u.id_usuario
      return Number(raw) || 0
    },
    filtradas() {
      let lista = this.filas || []
      if (this.filtroEscuela) {
        lista = lista.filter((v) => Number(v.escuela) === Number(this.filtroEscuela))
      }
      if (!this.soloAsignadas) return lista
      return filasBonoRiDelUsuario(lista, this.getdatosUsuarioERPERP)
    },
    headersVisibles() {
      if (this.puedeGestionar) return this.headers
      return this.headers.filter((h) => h.value !== 'acciones')
    },
    rangoTexto() {
      const act = this.cicloAct && this.cicloAct.ciclo
      const sig = this.cicloSig && this.cicloSig.ciclo
      if (!act || !sig) return ''
      const corte = this.fecha_corte ? ` · corte ${this.fecha_corte}` : ''
      return `(${act} → ${sig}${corte})`
    },
    resumenEscuela() {
      const vistos = {}
      const porPlantel = []
      let reinscribibles = 0
      let objetivo = 0
      let lleva = 0
      let bono = 0
      this.filtradas.forEach((f) => {
        const idp = Number(f.id_plantel)
        if (vistos[idp]) return
        vistos[idp] = true
        const obj = Number(f.objetivo) || 0
        const lle = Number(f.lleva_s2) || 0
        const rei = Number(f.reinscribibles) || 0
        reinscribibles += rei
        objetivo += obj
        lleva += lle
        if (f.alcanzado_s2) bono += Number(f.bono_general) || 0
        porPlantel.push({
          id_plantel: idp,
          plantel: f.plantel,
          reinscribibles: rei,
          objetivo: obj,
          lleva: lle,
          faltan: Math.max(0, obj - lle),
          pct: obj > 0 ? Math.min(100, Math.round((lle * 100) / obj)) : 0,
          meta: Number(f.meta) || 75,
        })
      })
      const pct = objetivo > 0 ? Math.min(100, Math.round((lleva * 100) / objetivo)) : 0
      return {
        reinscribibles,
        objetivo,
        lleva,
        faltan: Math.max(0, objetivo - lleva),
        bono,
        pct,
        planteles: porPlantel.length,
        porPlantel,
      }
    },
  },

  watch: {
    escuela(val) {
      if (val) this.filtroEscuela = Number(val)
    },
    filtradas: {
      handler() { this.emitirResumen() },
      deep: true,
    },
    cargandoAvance() { this.emitirResumen() },
  },

  mounted() {
    this.cargarFilas()
  },

  methods: {
    mostrarNum(valor) {
      if (valor === null || valor === undefined || valor === '') return '—'
      return valor
    },
    faltanDe(item) {
      if (!item) return 0
      if (item.faltan != null && item.faltan !== '') return Math.max(0, Number(item.faltan) || 0)
      const objetivo = Number(item.objetivo) || 0
      const lleva = Number(item.lleva_s2 != null ? item.lleva_s2 : item.lleva) || 0
      return Math.max(0, objetivo - lleva)
    },
    formatMoney(valor) {
      const n = Number(valor)
      if (!Number.isFinite(n)) return '—'
      return n.toLocaleString('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 2 })
    },
    nombreArchivoExcel() {
      const act = this.cicloAct && this.cicloAct.ciclo
        ? String(this.cicloAct.ciclo).replace(/\s+/g, '_')
        : ''
      const escuela = Number(this.filtroEscuela) === 2
        ? 'FAST'
        : Number(this.filtroEscuela) === 1
          ? 'INBI'
          : 'todas'
      const partes = ['bono_ri', escuela]
      if (act) partes.push(act)
      partes.push(new Date().toISOString().slice(0, 10))
      return partes.join('_') + '.xlsx'
    },
    descargarExcel() {
      const filas = this.filtradas || []
      if (!filas.length) {
        this.validarError('No hay datos para descargar')
        return
      }
      const hoja = filas.map((f) => ({
        Persona: f.nombre_completo || '',
        Plantel: f.plantel || '',
        Escuela: Number(f.escuela) === 2 ? 'FAST' : 'INBI',
        Reinscribibles: Number(f.reinscribibles) || 0,
        'Meta %': Number(f.meta) || 0,
        Objetivo: Number(f.objetivo) || 0,
        'Semana 2': Number(f.lleva_s2) || 0,
        Faltan: this.faltanDe(f),
        'Avance %': Number(f.pct_s2) || 0,
        'Bono general': Number(f.bono_general) || 0,
        'Bono personal': Number(f.bono_personal) || 0,
      }))
      const ws = XLSX.utils.json_to_sheet(hoja)
      ws['!cols'] = [
        { wch: 36 },
        { wch: 22 },
        { wch: 10 },
        { wch: 14 },
        { wch: 10 },
        { wch: 10 },
        { wch: 12 },
        { wch: 10 },
        { wch: 12 },
        { wch: 14 },
        { wch: 14 },
      ]
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Bono RI')
      XLSX.writeFile(wb, this.nombreArchivoExcel())
    },
    extraerFilas(response) {
      const data = (response && response.data) || (response && response.body) || response || {}
      if (Array.isArray(data.filas)) return data.filas
      if (Array.isArray(data)) return data
      return []
    },
    urlBonoRi(ruta) {
      if (!this.soloAsignadas) return ruta
      return ruta + (ruta.indexOf('?') >= 0 ? '&' : '?') + 'solo_asignadas=1'
    },
    emitirResumen() {
      this.$emit('resumen', {
        resumen: this.resumenEscuela,
        filas: this.filtradas,
        cicloAct: this.cicloAct,
        cicloSig: this.cicloSig,
        fecha_corte: this.fecha_corte,
        congelado: this.congelado,
        cargando: this.cargando || this.cargandoAvance,
      })
    },
    cargarFilas() {
      this.cargando = true
      return this.$http.get(this.urlBonoRi('kpi.bono.ri')).then((response) => {
        const filas = this.extraerFilas(response)
        const data = (response && response.data) || (response && response.body) || {}
        this.filas = filas
        this.alumnosPorPlantel = data.alumnosPorPlantel || {}
        this.cicloAct = data.cicloAct || null
        this.cicloSig = data.cicloSig || null
        this.fecha_corte = data.fecha_corte || ''
        this.congelado = !!data.congelado
        if (data.bloqueado != null) this.bloqueado = !!data.bloqueado
        if (this.filas.length) this.cargarAvance()
      }).catch((error) => {
        const msg = (error && error.response && error.response.data && error.response.data.message)
          || (error && error.message)
          || 'No se pudo cargar el bono de RI'
        this.validarError(msg)
      }).finally(() => {
        this.cargando = false
      })
    },
    aplicarAvance(filasAvance, alumnosPorPlantel) {
      const map = {}
      ;(filasAvance || []).forEach((f) => {
        map[Number(f.id_plantel)] = f
      })
      this.filas = this.filas.map((f) => {
        const src = map[Number(f.id_plantel)]
        if (!src) return f
        return {
          ...f,
          reinscribibles: src.reinscribibles,
          objetivo: src.objetivo,
          lleva: src.lleva,
          lleva_s2: src.lleva_s2,
          lleva_s5: src.lleva_s5,
          pct_s2: src.pct_s2,
          pct_s5: src.pct_s5,
          alcanzado: src.alcanzado,
          alcanzado_s2: src.alcanzado_s2,
          alcanzado_s5: src.alcanzado_s5,
          faltan: src.faltan != null
            ? src.faltan
            : Math.max(0, (Number(src.objetivo) || 0) - (Number(src.lleva_s2) || 0)),
        }
      })
      if (alumnosPorPlantel) this.alumnosPorPlantel = alumnosPorPlantel
    },
    cargarAvance() {
      this.cargandoAvance = true
      return this.$http.get(this.urlBonoRi('kpi.bono.ri.avance')).then((response) => {
        const data = (response && response.data) || (response && response.body) || {}
        const filas = this.extraerFilas(response)
        if (filas.length) this.aplicarAvance(filas, data.alumnosPorPlantel || {})
        if (data.cicloAct) this.cicloAct = data.cicloAct
        if (data.cicloSig) this.cicloSig = data.cicloSig
        if (data.fecha_corte) this.fecha_corte = data.fecha_corte
        if (data.congelado != null) this.congelado = !!data.congelado
        if (data.bloqueado != null) this.bloqueado = !!data.bloqueado
      }).catch((error) => {
        const msg = (error && error.response && error.response.data && error.response.data.message)
          || (error && error.message)
          || 'No se pudo calcular el Lleva de RI'
        this.validarError(msg)
      }).finally(() => {
        this.cargandoAvance = false
      })
    },
    abrirAlumnos(item) {
      this.plantelSeleccion = (item && item.plantel) || ''
      this.personaSeleccion = (item && item.nombre_completo) || ''
      const idp = item && item.id_plantel
      const bloque = (idp != null && this.alumnosPorPlantel[idp])
        || (idp != null && this.alumnosPorPlantel[String(idp)])
        || {}
      if (Array.isArray(bloque)) {
        this.alumnosSeleccion = bloque
      } else {
        this.alumnosSeleccion = bloque.s2 || []
      }
      this.dialogAlumnos = true
    },
    valorInput(event) {
      const raw = event && event.target ? event.target.value : event
      if (raw === '' || raw == null) return 0
      const n = Number(raw)
      return Number.isFinite(n) && n >= 0 ? n : 0
    },
    guardarPlantel(item, campo, event) {
      let valor = this.valorInput(event)
      if (campo === 'meta' && valor > 100) valor = 100
      const idp = Number(item.id_plantel)
      this.filas = this.filas.map((f) => {
        if (Number(f.id_plantel) !== idp) return f
        const next = { ...f, [campo]: valor }
        const reinscribibles = Number(next.reinscribibles) || 0
        const meta = Number(next.meta) || 0
        next.objetivo = Math.round(reinscribibles * meta / 100)
        const s2 = Number(next.lleva_s2) || 0
        const s5 = Number(next.lleva_s5) || 0
        next.pct_s2 = reinscribibles > 0 ? Math.round(s2 * 100 / reinscribibles) : 0
        next.pct_s5 = reinscribibles > 0 ? Math.round(s5 * 100 / reinscribibles) : 0
        next.alcanzado_s2 = next.objetivo > 0 && s2 >= next.objetivo
        next.alcanzado_s5 = next.objetivo > 0 && s5 >= next.objetivo
        next.alcanzado = next.alcanzado_s2
        next.lleva = s2
        return next
      })
      const fila = this.filas.find((f) => Number(f.id_plantel) === idp) || item
      return this.$http.post('kpi.bono.ri.plantel', {
        id_plantel: fila.id_plantel,
        plantel: fila.plantel,
        bono_general: Number(fila.bono_general) || 0,
        meta: Number(fila.meta) || 0,
      }).catch((error) => {
        const msg = error && error.response && error.response.data && error.response.data.message
        this.validarError(msg || 'No se pudo guardar el plantel')
        this.cargarFilas()
      })
    },
    guardarPersonal(item, event) {
      const valor = this.valorInput(event)
      const id = item && item.id
      this.filas = this.filas.map((f) => {
        if (f.id !== id) return f
        return { ...f, bono_personal: valor }
      })
      return this.$http.post('kpi.bono.ri.asignacion.bono', {
        id,
        bono_personal: valor,
      }).catch((error) => {
        const msg = error && error.response && error.response.data && error.response.data.message
        this.validarError(msg || 'No se pudo guardar el bono personal')
        this.cargarFilas()
      })
    },
    abrirAgregar() {
      this.nuevoTrabajador = null
      this.nuevoPlantel = null
      this.dialogAgregar = true
      if (this.trabajadores.length && this.planteles.length) return
      this.$http.get('kpi.bono.ri.catalogos').then((response) => {
        const data = (response && response.data) || {}
        this.trabajadores = data.trabajadores || []
        this.planteles = data.planteles || []
      }).catch((error) => {
        const msg = error && error.response && error.response.data && error.response.data.message
        this.validarError(msg || 'No se pudieron cargar trabajadores y planteles')
      })
    },
    agregar() {
      if (!this.nuevoTrabajador || !this.nuevoPlantel) return
      this.guardando = true
      return this.$http.post('kpi.bono.ri.asignacion', {
        id_trabajador: this.nuevoTrabajador.id_trabajador,
        id_plantel: this.nuevoPlantel.id_plantel,
      }).then(() => {
        this.dialogAgregar = false
        this.validarSuccess('Persona agregada')
        return this.cargarFilas()
      }).catch((error) => {
        const msg = error && error.response && error.response.data && error.response.data.message
        this.validarError(msg || 'No se pudo agregar')
      }).finally(() => {
        this.guardando = false
      })
    },
    confirmarEliminar(item) {
      this.filaEliminar = item
      this.dialogEliminar = true
    },
    eliminar() {
      if (!this.filaEliminar) return
      this.guardando = true
      return this.$http.delete(`kpi.bono.ri.asignacion/${this.filaEliminar.id}`).then(() => {
        this.dialogEliminar = false
        this.filaEliminar = null
        this.validarSuccess('Persona quitada')
        return this.cargarFilas()
      }).catch((error) => {
        const msg = error && error.response && error.response.data && error.response.data.message
        this.validarError(msg || 'No se pudo quitar')
      }).finally(() => {
        this.guardando = false
      })
    },
  },
}
</script>

<style scoped>
.filtro-escuela {
  font-size: 13px;
}

.chip-lleva {
  cursor: pointer;
}
</style>
